import { useEffect, useRef } from "react";

export default function Modal({ label, onClose, children, testId, wide }) {
  const panelRef = useRef(null);

  useEffect(() => {
    const previous = document.activeElement;
    const node = panelRef.current;
    node?.focus();

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
        return;
      }
      if (e.key !== "Tab" || !node) return;
      const focusables = node.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown, true);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown, true);
      document.body.style.overflow = "";
      if (previous && previous.focus) previous.focus();
    };
  }, [onClose]);

  return (
    <div
      className="ank-veil"
      data-testid={`${testId}-veil`}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className={`ank-modal${wide ? " ank-modal-wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={label}
        tabIndex={-1}
        ref={panelRef}
        data-testid={testId}
      >
        <button
          type="button"
          className="ank-modal-close"
          onClick={onClose}
          data-testid={`${testId}-close-btn`}
        >
          CLOSE ✕
        </button>
        {children}
      </div>
    </div>
  );
}
